export default "__VITE_ASSET__b97659af__"